export default "__VITE_ASSET__D63P8iUn__"